<script setup lang="ts">
import { API_CONFIG, BACKEND_URL } from '@/services/apiConfig';
import { nextTick, onMounted, reactive, ref, toRaw, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const loading = ref(false);
const errorMessage = ref('');
const item = reactive({
    id: 0,
    slug: '',
    libelle: '',
    contenu_aide: '',
    created_at: '',
    fichier_photo: '',
    fichier_video: '',
    etat_valide: 0,
    type_aide: '',
    categorie_aide_id: 0,
    categorie_aide: {
        id: 0,
        libelle: ''
    }
});
const relatedItems = ref([] as any[]);
const videoPlayer = ref(null as any);
const previousRoute = ref('');
const isPlaying = ref(false);

onMounted(() => {
    const data: any = route.meta.startup_infos;
    Object.assign(item, data.tutoriel);
    relatedItems.value = data.related_tutoriels;
    previousRoute.value = route.meta.prevRoute as string;
});

watch(() => route.params.slug, (newSlug) => {
    fetchItem(newSlug)
});

async function fetchItem(slug: any) {
    try {
        loading.value = true;
        errorMessage.value = '';
        const response = await fetch(`${API_CONFIG.baseURL}/tutoriels/${slug}`, {
            method: 'GET',
            headers: API_CONFIG.headers
        });
        const data = await response.json();
        Object.assign(item, data.tutoriel);
        relatedItems.value = data.related_tutoriels;
    } catch (error: any) {
        errorMessage.value = error;
    } finally {
        loading.value = false;
    }
}

function playVideo() {
    console.log(item);
    if (!item.fichier_video) { return; }
    isPlaying.value = true;
    nextTick(() => {
        if (videoPlayer.value) {
            videoPlayer.value.play();
        }
    })
}

function stopVideo() {
    if (videoPlayer.value) {
        videoPlayer.value.pause();
    }
    isPlaying.value = false;
}


function formatDate(dateString: string, format = 'DD/MM/YYYY HH:mm') {
    if (!dateString) return "";

    const date = new Date(dateString);

    const map = {
        DD: String(date.getDate()).padStart(2, '0'),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        YYYY: date.getFullYear(),
        HH: String(date.getHours()).padStart(2, '0'),
        mm: String(date.getMinutes()).padStart(2, '0'),
        ss: String(date.getSeconds()).padStart(2, '0'),
    };

    let formatted = format;
    for (const [key, value] of Object.entries(map)) {
        formatted = formatted.replace(key, value as any);
    }

    return formatted;
}

</script>
<template>
    <div class="page-space"></div>
    <section class="container-small">
        
        <div class="s14_mobile">
            <div class="card px-3 py-3">
                <!--Image-->
                <!-- <img :src="BACKEND_URL + '/assets/aide/1000w/pix-aide-tutoriel2.jpg'" width="100%" class="rounded-15" alt="" /> -->

                <!--Video-->
                <div class="widget-img" id="video_layer" v-if="!isPlaying" @click="playVideo">
                    <div class="widget-media flex-center px-7 py-5 barMedia-anim cursor-pointer" v-if="item.fichier_video">
                        <img src="/public/icons/icon-play.svg" class="size-2xl" />
                    </div>
                    <img :src="BACKEND_URL + '/assets/aide/1000/' + item.fichier_photo" width="100%" />
                </div>
                
                <div class="s20 mb-4" id="video_container" v-if="isPlaying">
                    <video id="video_player" class="video-size" :poster="BACKEND_URL + '/assets/aide/1000/' + item.fichier_photo" autoplay controls>
                        <source :src="BACKEND_URL + '/assets/aide/' + item.fichier_video">
                    </video>
                </div>


                <h1 class="font-semibold text-black mt-3 mb-4 px-5 pb-2">{{ item.libelle }}</h1>
            </div>
            <p class="text-read px-5 mt-7" v-html="item.contenu_aide"></p>
        </div>

        <div class="s1_mobile">&nbsp;</div>
        <div class="clear-both h-20 show-mobile"></div>

        <div class="s5_mobile">
            <div class="grid1">
                <template v-for="rItem in relatedItems" :key="'related_item_' + rItem.id">
                    <router-link :to="'/tutoriels/' + rItem.slug">
                        <div class="card px-2 py-2">
                            <img :src="BACKEND_URL + '/assets/aide/1000/' + rItem.fichier_photo" width="100%" class="mb-5" alt="" v-if="rItem.fichier_photo" />
                            <h5 class="font-semibold text-black mt-3 mb-4 px-4">{{ rItem.libelle }}</h5>
                        </div>
                    </router-link>
                </template>
            </div>
        </div>

        <div class="clear-both h-70"></div>
    </section>
</template>
